<template>
<div class="chapter">
<div class="inner_page">
<div id="d57691ac4acf6-d1e479"><span id="pageix">
<p class="prelims-epigraph">Wandering oversea dreamer,</p>
<p class="prelims-epigraph">Hunting and hoarse, Oh daughter and mother,</p>
<p class="prelims-epigraph">Oh daughter of ashes and mother of blood,</p>
<p class="prelims-epigraph">Child of the hair let down, and tears,</p>
<p class="prelims-epigraph">Child of the cross in the south</p>
<p class="prelims-epigraph">And the star in the north,</p>
<p class="prelims-epigraph">Keeper of Egypt and Russia and France,</p>
<p class="prelims-epigraph">Keeper of England and Poland and Spain,</p>
<p class="prelims-epigraph">Make us a song for to-morrow.</p>
<p class="prelims-epigraph">Make us one new dream, us who forget,</p>
<p class="prelims-epigraph-space-after">Out of the storm let us have one star.</p>
<p class="prelims-epigraph">Struggle, Oh anvils, and help her.</p>
<p class="prelims-epigraph">Weave with your wool. Oh winds and skies.</p>
<p class="prelims-epigraph">Let your iron and copper help,</p>
<p class="prelims-epigraph-space-after">Oh dirt of the old dark earth.</p>
<p class="prelims-epigraph">Wandering oversea singer,</p>
<p class="prelims-epigraph">Singing of ashes and blood,</p>
<p class="prelims-epigraph">Child of the scars of fire,</p>
<p class="prelims-epigraph">Make us one new dream, us who forget.</p>
<p class="prelims-epigraph-space-after">Out of the storm let us have one star.</p>
<p class="prelims-epigraph-source">Carl Sandburg, <em class="italic ">Smoke and Steel</em>, <em class="italic ">‘</em>IV. Playthings of the Wind, 12. Prayers After World War,’ 1922</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106519_epub_epi.vue?71f7cd5f